export default __webpack_public_path__ + "static/media/trailer_icon.3c0b10ab.svg";